/** Número de empenho: AAAA + NE + sequência (ex.: 2025NE02173). Vazio é permitido. */
export default function ()
{
	return {
		regex: /^$|^\d{4}NE\d+$/i,
		filter: /\s+/g,
	};
}
